import { observable, action } from 'mobx'
import * as defaultConst from '../constants/default_constants'
import EnumEditStoreFn from './entity_confs/enum_edit'
import UserState from './user'
import sortBy from 'lodash/sortBy'
import { LINKS_LIST } from '../constants/link_constants'

export default class OptionsState extends UserState {
  optionsLoadInfo = {}
  dirty = {}
  dirtyTimestamp = Math.round((new Date()).getTime() / 1000)
  entityList = [
    { value: defaultConst.ENTNAMES.ARCHIVE, label: LINKS_LIST[defaultConst.ENTNAMES.ARCHIVE] },
    { value: defaultConst.ENTNAMES.CLIENTS, label: LINKS_LIST[defaultConst.ENTNAMES.CLIENTS] },
    { value: defaultConst.ENTNAMES.CONTRACTITEMS, label: LINKS_LIST[defaultConst.ENTNAMES.CONTRACTITEMS] },
    { value: defaultConst.ENTNAMES.CONTRACTS, label: LINKS_LIST[defaultConst.ENTNAMES.CONTRACTS] },
    { value: defaultConst.ENTNAMES.CONTRACT_TIME_RESTRICTIONS, label: LINKS_LIST[defaultConst.ENTNAMES.CONTRACT_TIME_RESTRICTIONS] },
    { value: defaultConst.ENTNAMES.ENUMS, label: LINKS_LIST[defaultConst.ENTNAMES.ENUMS] },
    { value: defaultConst.ENTNAMES.FILMCARGO_HELP, label: LINKS_LIST[defaultConst.ENTNAMES.FILMCARGO_HELP] },
    { value: defaultConst.ENTNAMES.FILMS, label: LINKS_LIST[defaultConst.ENTNAMES.FILMS] },
    { value: defaultConst.ENTNAMES.FINANCIAL_REPORTS, label: LINKS_LIST[defaultConst.ENTNAMES.FINANCIAL_REPORTS] },
    { value: defaultConst.ENTNAMES.FP_CATEGORIES, label: LINKS_LIST[defaultConst.ENTNAMES.FP_CATEGORIES] },
    { value: defaultConst.ENTNAMES.FP_HOMESETT, label: LINKS_LIST[defaultConst.ENTNAMES.FP_HOMESETT] },
    { value: defaultConst.ENTNAMES.FP_PRICING, label: LINKS_LIST[defaultConst.ENTNAMES.FP_PRICING] },
    { value: defaultConst.ENTNAMES.FP_TESTING, label: LINKS_LIST[defaultConst.ENTNAMES.FP_TESTING] },
    { value: defaultConst.ENTNAMES.PERSONS, label: LINKS_LIST[defaultConst.ENTNAMES.PERSONS] },
    { value: defaultConst.ENTNAMES.PPROLLS, label: LINKS_LIST[defaultConst.ENTNAMES.PPROLLS] },
    { value: defaultConst.ENTNAMES.PUBLISH, label: LINKS_LIST[defaultConst.ENTNAMES.PUBLISH] },
    { value: defaultConst.ENTNAMES.RATING, label: LINKS_LIST[defaultConst.ENTNAMES.RATING] },
    { value: defaultConst.ENTNAMES.REPORTS, label: LINKS_LIST[defaultConst.ENTNAMES.REPORTS] },
    { value: defaultConst.ENTNAMES.RIGHTS, label: LINKS_LIST[defaultConst.ENTNAMES.RIGHTS] },
    { value: defaultConst.ENTNAMES.SHOWREPORTS, label: LINKS_LIST[defaultConst.ENTNAMES.SHOWREPORTS] },
    { value: defaultConst.ENTNAMES.VATRATES, label: LINKS_LIST[defaultConst.ENTNAMES.VATRATES] },
    { value: defaultConst.ENTNAMES.XRATES, label: LINKS_LIST[defaultConst.ENTNAMES.XRATES] },
    { value: defaultConst.ENTNAMES.YOUTUBE_ASSETS, label: LINKS_LIST[defaultConst.ENTNAMES.YOUTUBE_ASSETS] }
  ]

  // map of all loaded options. In future can be managed in LUR manner
  @observable options = observable.map({
    video_type: [
      { value: 'FILM', label: 'film' },
      { value: 'SERIES', label: 'series' },
      { value: 'SEASON', label: 'season' },
      { value: 'EPISODE', label: 'episode' },
      { value: 'BUNDLE', label: 'bundle' }
    ],
    right_type: [
      { value: 'r', label: 'readonly' },
      { value: 'rw', label: 'modify' }
    ],
    reporttypes: [
      { value: 'report', label: 'Report' },
      { value: 'extern', label: 'External' },
      { value: 'filter', label: 'Filter' }
    ],
    pprollsConditions: [
      { value: 'platforms', label: 'Platforms' },
      { value: 'categories', label: 'Categories' },
      { value: 'homepage', label: 'Homepage settings' },
      { value: 'tiers', label: 'Tiers' },
      { value: 'pricings', label: 'Tiers pricings' },
      { value: 'film', label: 'Film' }
    ],
    playPosition: [
      { value: 'before' },
      { value: 'after' },
      { value: 'both' }
    ],
    playUseFor: [
      { value: 'feature' },
      { value: 'preview' },
      { value: 'both' }
    ],
    entityname: [...this.entityList],
    filmcargo_help_elements: [
      ...this.entityList.map(i => {
        i.value === 'contractitems' && (i.label = 'Contract Titles')
        return i
      }),
      { value: 'clients/settings', label: 'Clients > Settings' },
      { value: 'clients/contracts', label: 'Clients > Contracts' },
      { value: 'clients/payments', label: 'Clients > Payments' },

      { value: 'contractitems/settings', label: 'Contract Titles > Settings' },
      { value: 'contractitems/rights', label: 'Contract Titles > Rights' },
      { value: 'contractitems/costs', label: 'Contract Titles > Costs' },
      { value: 'contractitems/shares', label: 'Contract Titles > Shares' },
      { value: 'contractitems/rights_costs', label: 'Contract Titles > Rights costs' },

      { value: 'contracts/settings', label: 'Contracts > Settings' },
      { value: 'contracts/contract_costs', label: 'Contracts > Constract costs' },
      { value: 'contracts/contract_overview', label: 'Contracts > Contract overview' },
      { value: 'contracts/financial_reports', label: 'Contracts > Financial reports' },
      { value: 'contracts/contract_payments', label: 'Contracts > Payments' },
      { value: 'contracts/contract_payments/amount_to_be_paid_calculated', label: 'Contracts > Payments > Amount payable calculated' },
      { value: 'contracts/contract_payments/recalculate_all_button', label: 'Contracts > Payments > Recalculate all (button)' },
      { value: 'contracts/contract_payments/recalculate_amount_paid_button', label: 'Contracts > Payments > Recalculate transfer amount (button)' },
      { value: 'contracts/shares', label: 'Contracts > Shares' },

      { value: 'films/common', label: 'Films > Common' },
      { value: 'films/common/settings', label: 'Films > Common > Settings' },
      { value: 'films/common/languages', label: 'Films > Common > Languages' },
      { value: 'films/common/ratings', label: 'Films > Common > Ratings' },
      { value: 'films/common/episodes', label: 'Films > Common > Episodes' },
      { value: 'films/common/lang_title_synopsis', label: 'Films > Common > Languages for title and synopsis' },
      { value: 'films/common/download_omdb_button', label: 'Films > Common > Download OMDb data (button)' },
      { value: 'films/common/roles', label: 'Films > Common > Cast and crew' },
      { value: 'films/common/hvsds', label: 'Films > Common > Home Video Street Date settings' },
      { value: 'films/common/bundledFilms', label: 'Films > Common > Bundled films' },

      { value: 'films/FP', label: 'Films > FlyPrivate' },
      { value: 'films/FP/uploads', label: 'Films > FlyPrivate > Uploads' },
      { value: 'films/FP/subtitles', label: 'Films > FlyPrivate > Subtitles' },
      { value: 'films/FP/pricings', label: 'Films > FlyPrivate > Pricings' },
      { value: 'films/FP/categories', label: 'Films > FlyPrivate > Categories' },
      { value: 'films/FP/videoids', label: 'Films > FlyPrivate > Video IDs' },
      { value: 'films/FP/pprolls', label: 'Films > FlyPrivate > Pre/post-rolls' },

      { value: 'films/AM', label: 'Films > Amazon' },
      { value: 'films/GP', label: 'Films > Google Play' },
      { value: 'films/iT', label: 'Films > iTunes' },
      { value: 'films/MIC', label: 'Films > Microsoft' },
      { value: 'films/UPC', label: 'Films > UPC' },
      { value: 'films/YT', label: 'Films > YouTube' },
      { value: 'films/YT/assets', label: 'Films > YouTube > Assets' },
      { value: 'films/YT/videos', label: 'Films > YouTube > Videos' },

      { value: 'flyprivate_pricings/details', label: 'FlyPrivate pricings > Details' },
      { value: 'financial_reports/download', label: 'Financial reports > Download selected (button)' },

      { value: 'batch/update', label: 'Batch > Update (button)' },
      { value: 'batch/merge', label: 'Batch > Merge (button)' },
      { value: 'batch/return', label: 'Batch > Return (button)' },
      { value: 'batch/close', label: 'Batch > Close (button)' },
      { value: 'batch/overwrite', label: 'Batch > Overwrite (button)' },
      { value: 'batch/set-as-inactive', label: 'Batch > Set as inactive (button)' },
      { value: 'batch/uploadarchive', label: 'Batch > Move uploaded files to archive (button)' },

      { value: 'reports/parameters', label: 'Reports > Parameters' },
      { value: 'report/download_csv_button', label: 'Report > Download CSV (button)' },
      { value: 'report/download_pdf_list_button', label: 'Report > Download PDF list (button)' },
      { value: 'report/download_pdf_table_button', label: 'Report > Download PDF table (button)' },
      { value: 'report/apply_filters', label: 'Report > Apply filters' },
      { value: 'report/clean_filters', label: 'Report > Clean filters' }
    ]
  })

  markDirty (name) {
    this.dirty[name] = null
  }

  dirtyAllUpdate (force = false) {
    const currentTimestamp = Math.round((new Date()).getTime() / 1000)
    if (force || currentTimestamp > (this.dirtyTimestamp + (defaultConst.UPDATE_OPTIONS_INTERVAL * 60))) {
      this.dirtyTimestamp = currentTimestamp
      Array.from(this.options.keys()).map(v => { this.markDirty(v) })
      return true
    }
    return false
  }

  loadAllOptions (requiredOptions) {
    // ADD FILMCARGO_HELP OPTION FOR EVERY PAGE IN CARGO AS OPTIONS
    requiredOptions.push(['filmcargo_help', '/filmcargo_help?attrs=["path", "value"]', 'path'])
    const promises = requiredOptions.map(i => {
      if (Array.isArray(i)) {
        return this.loadOptions(i[0], i[1], i[2])
      } else {
        return this.loadEnumOptions(i)
      }
    })
    return Promise.all(promises)
  }

  @action // loads options from enum table
  loadEnumOptions (name, update = false) {
    const query = `/enums/options/${encodeURIComponent(name)}?lang=en`
    return this._loadOptions(name, query, 'text', null, update)
  }

  @action
  loadOptions (name, query, sortcol, modifier = null, update = false) {
    if (Array.isArray(name) === true) {
      // sometimes basic params comes as Array
      sortcol = name[2]
      query = name[1]
      name = name[0]
    }
    return this._loadOptions(name, query, sortcol, modifier, update)
  }

  _loadOptions (name, query, sortcol, modifier = null, update = false) {
    // don't load options after logout
    if (!this.userLoggedIn) {
      return false
    }
    // load NEW options if this.dirty
    if (this.dirtyAllUpdate() || !(name in this.optionsLoadInfo) || name in this.dirty || update) {
      this.options.set(name, [])
      this.optionsLoadInfo[name] = this.requester.call(query).then((result) => {
        if (result) {
          modifier && result.data.map(modifier)
          const sorted = sortBy(result.data, [sortcol])
          this.options.set(name, sorted)
          delete this.dirty[name]
        }
      }).catch(this.onRequesterError.bind(this))
    }
    return this.optionsLoadInfo[name]
  }

  /* search for textToFind in enum table with given optionName */
  isTextOptionAvailable (textToFind, optionName) {
    const data = this.options.get(optionName)
    return data.find((option) => (textToFind === option.text.toLowerCase()))
  }

  addEnumOption (option, parent) {
    if (this.options.has(parent)) {
      this.options.get(parent).push(option)
    }
  }

  @action
  saveEnumOMDB (parent, lang, text, value) {
    // TODO: tohle vykopnout a nahradit obecnou save metodou
    const data = [{ parent, lang, text, value }]
    this.requester.call('/enums', 'post', data)
      .then((response) => {
        this.addMessage(
          'Code "' + value + '" was added to database under enum parent "' + parent + '" ',
          'success',
          3000)
      })
      .catch(this.onRequesterError.bind(this))
  }

  @action
  showEnumEdit (id) {
    try {
      const EnumEditStore = EnumEditStoreFn(this)
      this.cv = new EnumEditStore()
      this.cv.init(this.requester, this.onRequesterError.bind(this))
    } catch (err) {
      console.error(err)
    }
  }
}
